<cdk-virtual-scroll-viewport *ngIf="offeneGutachten.result$ | async" [itemSize]="69" [style.height]="height">
  <nz-list nzSize="large" [nzLoading]="$loading | async">
    <nz-list-item *cdkVirtualFor="let entry of (offeneGutachten.result$ | async).offeneGutachten" (click)="set(entry)">
      <nz-list-item-meta [nzDescription]="ListDescription">
        <ng-template #ListDescription>
          <!--- << description    -->
          <!---    description >> -->
        </ng-template>
        <nz-list-item-meta-title>
          <a>
            <!--- << content    -->
            <!---    content >> -->
          </a>
        </nz-list-item-meta-title>
      </nz-list-item-meta>
      <ul nz-list-item-actions>
        <nz-list-item-action>
          <!--- << extra    -->
          <!---    extra >> -->
          <a><i nz-icon nzType="edit" nzTheme="outline"></i></a>
        </nz-list-item-action>
      </ul>
    </nz-list-item>
  </nz-list>
</cdk-virtual-scroll-viewport>
